import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import './ShowNews.css';

function ShowNews() {
    const [staffs, setStaffs] = useState([]);

          useEffect(() => {
            // Fetch all staff data when the component mounts
            axios
              .get("https://school-web-server-eight.vercel.app/news")
              .then((result) => setStaffs(result.data))
              .catch((err) => console.log(err));
          }, []);
        
    const handleDelete = async (id, imageName) => {
        try {
            // Delete the staff from the backend
            await axios.delete(`https://school-web-server-eight.vercel.app/deleteNews/${id}`);

   
            // Update the local state to remove the deleted staff
            setStaffs(staffs.filter(staff => staff._id !== id));
        } catch (error) {
            console.error('Error deleting staff:', error);
        }
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based month
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        // <>
        //     <div className='add'>
        //         <div className='content'>
        //             <div className='header-News-1'>
        //                 <div className='header'>
        //                     <h1>ข่าวประชาสัมพันธ์</h1>
        //                     <p></p>
        //                 </div>

        //                 <Link to='create' className='add-staff'>เพิ่มหัวข้อข่าวประชาสัมพันธ์</Link>
        //             </div>

        //             <div className='staff-list'>
        //                 {staffs.map((staff) => (
        //                     <div className='staff-card' key={staff._id}>
        //                         <img
        //                             src={`https://http://localhost:3003/news/${staff.image}`}
        //                             alt=""
        //                         />
        //                         <div className='info'>
        //                             <h3>{staff.name}</h3>
        //                             <p>{staff.position}</p>
        //                             <p>{staff.email}</p>
        //                         </div>
        //                         <div className='actions'>
        //                             <Link to={`update/${staff._id}`} className='update-info'>อัพเดทข้อมูล</Link>
        //                             <button className='delete-staff' onClick={() => handleDelete(staff._id, staff.image)}>ลบข้อมูลทั้งหมด</button>
        //                         </div>
        //                     </div>
        //                 ))}
        //             </div>
        //         </div>
        //     </div>
        // </>
        <>
        <div className='news1'>
                <div className='header-news1'>          
                {/* <h1 className="news-im">ข่าวประชาสัมพันธ์สำคัญ</h1> */}
                <Link to='create' className='add-news'>เพิ่มหัวข้อข่าวประชาสัมพันธ์</Link>
                </div>
                
            <table className='table'>
                        <tbody >
                            {staffs.map((staff) => (
                                <tr className='card' key={staff._id}>
                                    <td>
                                        <img
                      src={`https://school-web-server-eight.vercel.app/news/${staff.image}`}
                      alt=""
                      style={{
                        width: "auto",
                        height: "100px",
                        objectFit: "fill",
                      }}
                    />
                                        
                                    </td>
                                    <td>{staff.name}</td>
                                    <td>{formatDate(staff.position)}</td>
                                    <td>{staff.link}</td>
                                    <td>
                                    <Link to={`update/${staff._id}`} className='update-info-news'>อัพเดทข้อมูล</Link>
                                        <button className='delete-news' onClick={() => handleDelete(staff._id, staff.image)}>ลบทั้งหมด</button>
                                    </td>
                                </tr>
                            ))}
                            
                        </tbody>
                    </table>
        </div>
    </>
    );
}

export default ShowNews;